<template>
  <div id="empty">
    <section class="content empty-body">
      <div>
        <img src="../assets/no_data.png" alt="">
      </div>
      <p class="mt-20 empty-text">
        暂时没有需求，快去发布需求吧~
      </p>
      <div class="custom-btn" @click="publish">
        前往发布需求
      </div>
    </section>
</div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    publish() {
      this.$router.push({name: 'publish'})
    }
  }
}
</script>
<style scoped>
.empty-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.empty-text {
  font-size: 16px;
  color: #CCCCCC;
  letter-spacing: 0;
}
.custom-btn {
  border: 1px solid #4285F4;
  border-radius: 21px;
  border-radius: 21px;
  height: 36px;
  width: 140px;
  font-size: 16px;
  color: #4285F4;
  text-align: center;
  line-height: 36px;
  margin: 30px 0 55px;
  cursor: pointer;
}
</style>